
import {Component, Prop, Vue} from 'vue-property-decorator';
import {readUserProfile} from '@/store/main/getters';
import {rules} from '@/utils';
import {IEmailTemplate} from '@/interfaces/email-template';
import {dispatchSentDirectMail} from '@/store/main/actions';

@Component({})
export default class SentEmailDialog extends Vue {
  @Prop() public userInfo!: any;
  private dialog: boolean = false;
  private valid: boolean = true;
  private rules: any = rules;
  private emailTemplate = {} as IEmailTemplate;

  public async mounted() {
    this.emailTemplate = {
      email_to: '',
      email_from: this.currentUser?.email,
      subject: 'Mala Direta',
      issuer_name: `${this.currentUser?.fullname}`,
      msg: '',
    } as IEmailTemplate;
    if (this.userInfo && this.userInfo?.registered_by_user) {
      this.emailTemplate.email_to = this.userInfo?.registered_by_user_email;
      this.emailTemplate.subject = `Informações sobre o formulário ${this.userInfo.id}`;
    } else {
      this.emailTemplate.email_to = this.userInfo?.email;
    }
  }

  public async sentEmail() {
    // @ts-ignore
    const form: any = this.$refs.form_sent_email;
    if (form.validate()) {
      await dispatchSentDirectMail(this.$store, this.emailTemplate);
      this.dialog = false;
      this.emailTemplate.msg = '';
    }
  }


  private get currentUser() {
    return readUserProfile(this.$store);
  }

}
